import f from "./index625.js";
import m from "./index626.js";
import i from "./index627.js";
import r from "./index628.js";
import t from "./index629.js";
import { withNoopInstall as o, withInstall as s } from "./index604.js";
s(f, {
  Aside: m,
  Footer: i,
  Header: r,
  Main: t
});
const l = o(m);
o(i);
o(r);
o(t);
export {
  l as ElAside
};
